import { c as _c } from "react/compiler-runtime";
import { useUpdateData } from 'shared/hooks/use-update-data';
import { COURSE_API } from '../../courses/curriculum/api/course-curriculum-api';
import { LectureId } from '../../courses/curriculum/types/lecture-interface';
export const useUpdateLectureEmail = lectureId => {
  const $ = _c(2);
  const t0 = `${COURSE_API}/lecture/${lectureId}/email`;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      api: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useUpdateData(t1);
};